import styled, { css } from "styled-components";

export const PressListTable = styled.table`
  width: 100%;
  background-color: ${({ theme }) => theme.color.neural.gray00};
  margin-top: 2.4rem;
`;

export const CommonTdStyle = css`
  position: relative;
  padding: var(--Spacing-12, 1.2rem) var(--Spacing-8, 0.8rem);
  line-height: 1.8rem;
  border: 1px solid var(--Color-Common-Border-Tertiary, #e5e7eb);
  font-size: 1.2rem;
  font-style: normal;
  font-weight: 400;
  line-height: 130%;
  vertical-align: top;
`;

export const CommonErrorStyles = css`
  background-color: ${({ theme }) => theme.color.neural.gray01};
  color: rgba(60, 71, 87, 0.5);

  a {
    color: rgba(60, 71, 87, 0.5);
  }

  span {
    color: rgba(60, 71, 87, 1);
  }
`;

export const PressListTableBody = styled.tbody`
  background-color: #ffffff;
`;

export const PressListTableTr = styled.tr<{
  isError: boolean;
}>`
  ${({ isError }) =>
    isError &&
    css`
      td {
        ${CommonErrorStyles}
      }
    `}
`;

export const PressListTablePressId = styled.td`
  ${CommonTdStyle}
  width: 6.4rem;
  background-color: ${({ theme }) => theme.color.neural.gray01};
`;

export const PressListTableCompany = styled.td`
  ${CommonTdStyle}
  width: 12rem;
`;

export const PressListTableEditor = styled.td`
  ${CommonTdStyle}
  width: 8.8rem;
`;

export const PressListTableClassification = styled.td`
  ${CommonTdStyle}
  width: 13.6rem;
`;

export const PressListTableDate = styled.td`
  ${CommonTdStyle}
  width: 10.4rem;
`;

export const PressListTableUnsuitable = styled.td<{
  isReviewRequired: boolean;
  isUnsuitable: boolean;
  isModalOpen?: boolean;
}>`
  ${CommonTdStyle}
  width: 8.8rem;
  white-space: pre-line;
  background-color: ${({ isUnsuitable, isReviewRequired }) => {
    if (isReviewRequired) {
      return "#FFFAA3";
    }
    if (isUnsuitable) {
      return "rgba(219, 15, 114, 0.1)";
    }

    return "transparent";
  }};

  &:hover {
    background-color: ${({ isReviewRequired }) => {
      if (isReviewRequired) {
        return "#FFF875";
      }

      return "var(--Color-Common-Bg-Warning-Subtle, #feece6)";
    }};
  }

  &:active {
    background-color: ${({ isReviewRequired }) => {
      if (isReviewRequired) {
        return "#FFF647";
      }

      return "var(--Color-Common-Bg-Danger-Subtle, #fde7e9)";
    }};
  }

  ${({ isModalOpen, isReviewRequired }) =>
    isModalOpen &&
    css`
      background: ${isReviewRequired
        ? "#FFF875"
        : "var(--Color-Common-Bg-Danger-Subtle, #fde7e9)"};
    `}
`;

export const PressListTablePublishable = styled.td`
  ${CommonTdStyle}
  width: 8.8rem;
  text-align: center;
  cursor: pointer;
  padding: 0;
  vertical-align: middle;
`;

export const StatusTableData = styled.td<{ code: string }>`
  ${CommonTdStyle}
  width: 7.2rem;
  text-align: center;
  vertical-align: middle;
`;

export const ClassificationTableData = styled.td<{
  status: string;
}>`
  ${CommonTdStyle}
  width: 13.6rem;

  ${({ status, theme }) =>
    ["S300"].includes(status) &&
    css`
      background-color: ${theme.color.neural.gray01};
      opacity: 0.5;
    `}
`;
